import React, { createContext, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [isAuthenticated, setIsAuthenticated] = useState(
        localStorage.getItem("isEmailAuthenticated") === "true"
    );

    const navigate = useNavigate();

    const login = () => {
        setIsAuthenticated(true);
        localStorage.setItem("isEmailAuthenticated", "true");
        navigate("/chat");
    };

    const logout = () => {
        setIsAuthenticated(false);
        localStorage.removeItem("isEmailAuthenticated");
        navigate("/login");
    };

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

export const useAuth = () => useContext(AuthContext);
